import firebase from "firebase";
const firebaseConfig = {
    apiKey: "AIzaSyD5tZXbC8WoHuKEOtPZlzQJAggFCkYnI_Y",
    authDomain: "wheretobuy-mdp.firebaseapp.com",
    projectId: "wheretobuy-mdp",
    storageBucket: "wheretobuy-mdp.appspot.com",
    messagingSenderId: "93695875711",
    appId: "1:93695875711:web:cdf40cb8c9a4da6cb77d4a",
    measurementId: "G-NJ00YLTEVF",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
